import { Controller } from "stimulus"

export default class extends Controller {
	static targets = ["mainMenu", "extraMarginElement"]
	connect() {
		// Call resize once on connect so we get the correct menu from start
		this.resize();
	}

	activate(event) {
		var menu_links = this.element.getElementsByClassName('main-menu-link');
		[].forEach.call(menu_links, function (menu_link) { menu_link.classList.remove('active'); });
		event.target.closest('a').classList.add('active');
	}

	resize() {
		window.isMobile = (window.innerWidth < 500 ? true : false);
		window.isLarge = (window.innerWidth >= 1280 ? true : false);
		if (window.isMobile) {
			this.mainMenuTarget.classList.add('floating');
			this.extraMarginElementTarget.style.marginTop = this.mainMenuTarget.getBoundingClientRect().height + 'px';
		} else {
			this.mainMenuTarget.classList.remove('floating');
			this.extraMarginElementTarget.style.marginTop = '0px';
			if (window.isLarge) {
				this.element.classList.add('side_menu');
				this.extraMarginElementTarget.style.marginLeft = this.mainMenuTarget.getBoundingClientRect().width + 'px';
			} else {
				this.element.classList.remove('side_menu');
				this.extraMarginElementTarget.style.marginLeft = '0px';
			}
		}
		this.mainMenuTarget.classList.remove('invisible');
	}
}